import { IAuditItem, IChainListItem } from '@/pages/ProofOfReserve/helper';
import { API2_HOST } from '@/utils/constants';

import fetchData from '../http';
import request from '../request';
import { IBaseResponse, IResult } from '../types/common';
import { IQueryChainInfoRes, IQueryPorInfoRes } from '../types/por';

interface IMerkleTreeNode {
  auditId: string;
  balances: {
    BTC: string;
    ETH: string;
    USDT: string;
  };
  type: 1 | 2;
  nonce?: string;
  hash: string;
  height: number;
}

// 查询merkle tree信息
export function postMerkleTreeInfo(params: any) {
  return fetchData.post<any>(`${API2_HOST}/cht/asset/page/por/queryMerkle`, {
    body: JSON.stringify(params),
  });
}
// 查询准备金
export const getQueryReserveInfo = () => {
  const url = `${API2_HOST}/cht/asset/page/por/queryReserve`;
  return fetchData.get<any>(url);
};

// 查询审计列表数据
export function getAuditList() {
  return fetchData.get<IBaseResponse<any>>(
    `${API2_HOST}/cht/asset/page/por/querySelfAuditList`,
  );
}

// 查询审计详情
export function getAuditItemInfo(params: { auditId: string }) {
  return fetchData.get<IBaseResponse<any>>(
    `${API2_HOST}/cht/asset/page/por/querySelfAudit`,
    {
      body: JSON.stringify(params),
    },
  );
}

// 查询资产
export function getAuditInfo() {
  return fetchData
    .get<IBaseResponse<any>>(
      `${API2_HOST}/cht/asset/page/por/queryHisBalancesInfo`,
    )
    .then((res) => {
      const { result } = res;
      const dateList: string[] = [];
      const dataSource: { [key: string]: Array<IAuditItem> } = {};
      if (result && Array.isArray(result.items)) {
        result.items?.forEach((item: any) => {
          const date = item.snapshotDt;
          dateList.push(date);
          try {
            if (item.amount) {
              const amount = JSON.parse(item.amount);
              const balance = Object.keys(amount).map((key) => ({
                asset: key,
                balance: amount[key],
                time: date,
              }));
              dataSource[date] = balance;
            }
          } catch (err: any) {
            console.log('dataSource', dataSource);
          }
        });
      }
      return {
        dateList,
        dataSource,
      };
    });
}
// 查询链信息
export function getChainInfo() {
  return fetchData
    .get<IBaseResponse<IQueryChainInfoRes>>(
      `${API2_HOST}/cht/asset/page/por/queryHisChainInfo`,
    )
    .then((res) => {
      const { result } = res;
      const dateList: string[] = [];
      const chainList: { [key: string]: IChainListItem[] } = {};
      if (result && Array.isArray(result.items)) {
        result.items.forEach((item) => {
          const date = item.snapshotDt;
          dateList.push(date);
          try {
            if (item.coinList) {
              const coinListObject = JSON.parse(item.coinList);
              const chainListItem = Object.keys(coinListObject).map((key) => ({
                coin: key,
                desc: 'Chain',
                label: coinListObject[key],
              }));
              chainList[date] = chainListItem;
            }
          } catch (err: any) {
            console.log('dataSource', err, chainList);
          }
        });
        console.log('chainList', chainList);
        return { chainList, dateList };
      }
    });
}
// 查询准备金率信息
export function getPorInfo() {
  return request.get<IBaseResponse<IQueryPorInfoRes>>(
    `${API2_HOST}/cht/asset/page/por/queryHisPorInfo`,
    {
      useCache: true,
    },
  );
}
